import script from "./updateCalendarModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./updateCalendarModal.vue?vue&type=script&setup=true&lang=ts"

import "./updateCalendarModal.vue?vue&type=style&index=0&id=06741852&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06741852"]])

export default __exports__